/**
 * 指挥台队员轨迹线显示偏好（localStorage）
 * 供显示设置与地图绘制读取；缺省安全，不抛错。
 */
const STORAGE_KEY = 'zhxt.command.trackVisualPrefs.v1';

export const DEFAULT_TRACK_VISUAL_PREFS = Object.freeze({
  lineWidth: 4,
  gapDashed: true,
  colorByMember: true,
  showOfflineInSummary: true,
  offlineMinutesHint: 5
});

function clampWidth(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return DEFAULT_TRACK_VISUAL_PREFS.lineWidth;
  return Math.min(10, Math.max(1, Math.round(v)));
}

export function loadTrackVisualPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_TRACK_VISUAL_PREFS };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return { ...DEFAULT_TRACK_VISUAL_PREFS };
    return {
      ...DEFAULT_TRACK_VISUAL_PREFS,
      lineWidth: clampWidth(parsed.lineWidth),
      gapDashed: parsed.gapDashed !== false,
      colorByMember: parsed.colorByMember !== false,
      showOfflineInSummary: parsed.showOfflineInSummary !== false,
      offlineMinutesHint: Number.isFinite(Number(parsed.offlineMinutesHint))
        ? Math.min(60, Math.max(1, Math.round(Number(parsed.offlineMinutesHint))))
        : DEFAULT_TRACK_VISUAL_PREFS.offlineMinutesHint
    };
  } catch (_) {
    return { ...DEFAULT_TRACK_VISUAL_PREFS };
  }
}

export function saveTrackVisualPrefs(next) {
  const merged = {
    ...DEFAULT_TRACK_VISUAL_PREFS,
    ...(next && typeof next === 'object' ? next : {}),
    lineWidth: clampWidth(next?.lineWidth)
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (_) { /* ignore quota */ }
  try {
    window.dispatchEvent(new CustomEvent('zhxt-track-visual-prefs', { detail: merged }));
  } catch (_) { /* ignore */ }
  return merged;
}

export function getTrackLineWidth() {
  return loadTrackVisualPrefs().lineWidth;
}

export function getTrackGapDashed() {
  return loadTrackVisualPrefs().gapDashed !== false;
}

/**
 * 把当前线宽应用到地图上已有的队员轨迹线图层（历史 track-* / 实时 real-time-track-*）。
 * 断段虚线仍在下次绘制/刷新时按 getTrackGapDashed 重建。
 */
export function applyTrackVisualPrefsToMap(map) {
  if (!map || typeof map.getStyle !== 'function') return 0;
  let style;
  try {
    style = map.getStyle();
  } catch (_) {
    return 0;
  }
  const layers = style?.layers || [];
  const width = getTrackLineWidth();
  let n = 0;
  layers.forEach((layer) => {
    const id = layer?.id || '';
    if (layer?.type !== 'line' || !id) return;
    const isMainTrack = (
      (id.startsWith('track-') || id.startsWith('real-time-track-'))
      && !id.endsWith('-hit')
      && !id.includes('-gap')
      && !id.includes('gap-')
    );
    if (!isMainTrack) return;
    try {
      map.setPaintProperty(id, 'line-width', width);
      n += 1;
    } catch (_) { /* ignore */ }
  });
  return n;
}

